export default function Navbar() {
  return (
    <nav className="navbar" id="nav">
      <div className="navbar-content">
        <img src="/logo.jpg" alt="Logo"/>
      <h2 className="Connie">ConnieAnsa</h2>
      </div>
      <div className="navbar-author">
        <h2 className="Mai">Mai Mahmoud</h2>
      </div>
    </nav>
  );
}
